// extracted by extract-css-chunks-webpack-plugin
module.exports = {"CustomBurgerBut":"XM298SJn","burgerLines":"PXHJa2ga","open":"Gk3kPRnx"};